import { Error } from "./Error";

const NotFoundPage = () => {
  return <Error />;
};
export default NotFoundPage;
